export default __webpack_public_path__ + "static/media/san-rafael-3.ae25bf9f.jpg";